module.exports = "/assets/data/1c48dca3374f67c878ed4f601db21f2f-W1A.data.json";